<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconExclamationMark',
  svgType: 'color',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-exclamation-mark', 'type-color'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg fill="none" viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path d="M0 0h24v24H0z"/><path fill="#fff" fill-rule="evenodd" d="M12 19.275a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0-4.725a1.125 1.125 0 0 1-1.125-1.125v-7.5a1.125 1.125 0 0 1 2.25 0v7.5c0 .62-.504 1.125-1.125 1.125"/>
    </template>
  </svg>
</template>